import { render, staticRenderFns } from "./editSticker.vue?vue&type=template&id=206ae8ec&scoped=true"
import script from "./editSticker.vue?vue&type=script&lang=js"
export * from "./editSticker.vue?vue&type=script&lang=js"
import style0 from "./editSticker.vue?vue&type=style&index=0&id=206ae8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ae8ec",
  null
  
)

export default component.exports